/* RESPONSIBLE TEAM: team-ai-insights */
import GlobalLoadingRoute from 'embercom/routes/base/global-loading-route';

export default class AnalyzeLoadingRoute extends GlobalLoadingRoute {}
